module.exports = __webpack_public_path__ + "img/default_email_header.dd32201c.png";